import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
// import moment from "moment";

export default function BookingRoom() {
  const [room, setRoom] = useState();
  const [user, setUser] = useState();
  const [showPopup, setShowPopup] = useState(false);

  const location = useLocation();
  const { checkIn, checkOut, adult, child, total, totalDays, rooms, quantity } = location.state || {};

  const [mode, setMode] = useState("Pay at Hotel");
  const { _id } = useParams();
  const navigate = useNavigate();

  const today = new Date().toISOString().split("T")[0];

  // ✅ Room Data
  async function getRoomData() {
    let response = await fetch("/api/roomcart", {
      method: "GET",
      headers: {
        "content-type": "application/json",
      }
    });
    response = await response.json();
    if (response.result === "Done") {
      let item = response.data.find((x) => x._id === _id);
      setRoom(item);
    }
  }

  // ✅ User Data
  async function getUserData() {
    const userId = localStorage.getItem("userid");
    let response = await fetch(`/api/user/${userId}`, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        "authorization": localStorage.getItem("token")
      }
    });
    response = await response.json();
    if (response.result === "Done") {
      console.log(response.data);
      
      setUser(response.data);
    }
  }

  // ✅ Booking Function
  async function bookRoom() {
    let item = {
      user: localStorage.getItem("userid"),
      bookingStatus: "Booking is Confirm",
      paymentMode: mode,
      paymentStatus: "Pending",
      checkIn: checkIn,
      // checkIn: moment(checkIn).format('DD-MM-YYYY'),
      // checkOut: moment(checkOut).format('DD-MM-YYYY'),
      checkOut: checkOut,
      total: total,
      date: new Date(),
      roomId: room._id,
      name: room.name,
      pic: room?.pic[0],
      price: room?.price,
      days: totalDays,
      adult: rooms[0]?.adult,
      child: rooms[0]?.child,
      qty: quantity,

    };
    let response = await fetch("/api/booking", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "authorization": localStorage.getItem("token")
      },
      body: JSON.stringify(item)
    });
    response = await response.json();
    if (response.result === "Done") {
      if (mode !== "Pay at Hotel")
        navigate("/payment/-1");
      else
        navigate("/confirmation");
    }
  }

  useEffect(() => {
    if (!localStorage.getItem("userid")) {
      navigate("/signin");
    } else {
      getRoomData();
      getUserData();
    }
  }, []);
          
        

  return (


 <div className="container my-5">
  <>
  {/* Booking Banner */}
  <div
    className="container-fluid p-0"
    style={{
      backgroundImage: "url('/images/payment/confirmPayment.png')", // Tum apna image path daal lena
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "300px",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      fontWeight: "bold",
      fontSize: "2.5rem",
    }}
  >
    <div style={{ backgroundColor: "rgba(0,0,0,0.4)", padding: "20px", borderRadius: "10px" }}>
      Booking Confirmation
    </div>
  </div>

  {/* Baaki ka pura Booking + User Details code yahan aayega */}
  <div className="container my-5">
    <div className="row">
      {/* LEFT: Booking Details */}
      {/* RIGHT: User + Payment */}
      {/* Tumhara pura pehle ka code yahan continue karega */}
    </div>
  </div>
</>

  <div className="row">
    <div className="col-md-6 mb-4">
      <div className="shadow-lg rounded-lg p-4 bg-white">
        <img
          src={`${room?.pic[0]}`}
          alt="Room"
          className="img-fluid rounded mb-4"
          style={{ height: "250px", objectFit: "cover", width: "100%" }}
        />
        <h2 className="text-center mb-4 font-weight-bold">Booking Details</h2>
        
        <ul className="list-group list-group-flush">
          <li className="list-group-item"><strong>Room ID:</strong> {room?._id}</li>
          <li className="list-group-item"><strong>Check-In:</strong> {checkIn}</li>
          <li className="list-group-item"><strong>Check-Out:</strong> {checkOut}</li>
          <li className="list-group-item"><strong>Adults:</strong> {rooms[0]?.adult}</li>
          <li className="list-group-item"><strong>Children:</strong> {rooms[0]?.child}</li>
          <li className="list-group-item"><strong>Room Price per Night:</strong> ₹{room?.finalPrice}</li>
          <li className="list-group-item"><strong>Total Nights:</strong> {totalDays}</li>
          <li className="list-group-item"><strong>Rooms Booked:</strong> {quantity}</li>
          <li className="list-group-item bg-light font-weight-bold">
            <strong>Total Amount:</strong> ₹{total}
          </li>
        </ul>
      </div>
    </div>

    <div className="col-md-6">
      {/* User Details */}
      <div className="shadow-lg rounded-lg p-4 bg-white mb-4">
        <h2 className="text-center mb-4 font-weight-bold">User Details</h2>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <th>Name</th>
              <td>{user?.name || "N/A"}</td>
            </tr>
            <tr>
              <th>Email</th>
              <td>{user?.email || "N/A"}</td>
            </tr>
            <tr>
              <th>Phone</th>
              <td>{user?.phone || "N/A"}</td>
            </tr>
            <tr>
              <th>Address</th>
              <td>{user?.address || "N/A"}</td>
            </tr>
            
          </tbody>
        </table>
      </div>

      {/* Payment Section */}
      <div className="shadow-lg rounded-lg p-4 bg-white">
        <h2 className="text-center mb-4 font-weight-bold">Payment Details</h2>

        <div className="form-group mb-4">
          <label htmlFor="paymentMode" className="font-weight-bold">Select Payment Mode</label>
          <select
            id="paymentMode"
            name="mode"
            className="form-control"
            onChange={(e) => setMode(e.target.value)}
            value={mode}
          >
            <option value="Pay at Hotel">Pay at Hotel</option>
            <option value="Net Banking">Net Banking / Card / UPI / EMI</option>
          </select>
        </div>

        <div className="text-center">
          <button
            className="btn btn-primary btn-lg w-50"
            onClick={bookRoom}
          >
            Confirm Booking
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


  );
}


